export default "__VITE_ASSET__IZq3LBuC__"